// extracted by mini-css-extract-plugin
export default {"lead__Approval__View":"styles_lead__Approval__View__aKIyS","back__Btn__Wrap":"styles_back__Btn__Wrap__bu9zo","back__Btn":"styles_back__Btn__5RUUq"};